import { LOCAL_STORAGE_KEY } from './constants';

export function isViewed(geoHash: string): boolean {
  const viewedClusters = localStorage.getItem(LOCAL_STORAGE_KEY)?.split(',') || [];

  return viewedClusters.some(viewedGeoHash => geoHash.startsWith(viewedGeoHash));
}
